import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { VehicleConfiguratorActions } from '../constants/configurator/vehicle_configurator_actions';
import { Filters } from '../constants/filter/filters';
import { getDefaultValueForFilter } from '../helper/filters/get_default_value_for_filter';
import { forOwn } from '../../../lib/utilities';
import { getValue } from '../../utilities/local_storage';

class VehicleFilterStoreClass extends ReduceStore {
    getInitialState() {
        const values = {};
        values[Filters.VEHICLE_MAKE] = getDefaultValueForFilter(Filters.VEHICLE_MAKE);
        values[Filters.VEHICLE_MODEL] = getDefaultValueForFilter(Filters.VEHICLE_MODEL);
        values[Filters.VEHICLE_YEAR] = getDefaultValueForFilter(Filters.VEHICLE_YEAR);
        values[Filters.VEHICLE_SERIES_CHASSIS] = getDefaultValueForFilter(Filters.VEHICLE_SERIES_CHASSIS);
        values[Filters.VEHICLE_ENGINE] = getDefaultValueForFilter(Filters.VEHICLE_ENGINE);
        values[Filters.VEHICLE_DETAILS] = getDefaultValueForFilter(Filters.VEHICLE_DETAILS);
        values[Filters.VEHICLE_TYRES] = getDefaultValueForFilter(Filters.VEHICLE_TYRES);
        values[Filters.TYRE_OPTIONS] = [];
        values[Filters.POSTCODE] = getValue('shippingPostcode') || getDefaultValueForFilter(Filters.POSTCODE);
        values[Filters.VEHICLE_NOT_PROVIDED_COMMENT] = '';
        values[Filters.VEHICLE_ID] = '';

        return {
            visible: false,
            visibleV2: false,
            fromTyreSize: false,
            postcodeInvalidMessage: false,
            vehicleNotProvidedLayerVisible: false,
            provideSizeMessage: '',
            provideIndexMessage: '',
            loadingCheck: '',
            outOfStock: '',
            tyreOptions: [],
            postcodeSuggestion: null,
            touched: false,
            infoLayerVisible: false,
            values
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.VEHICLE_CONFIGURATOR_ACTION) {
            switch (action.type) {
                case VehicleConfiguratorActions.SHOW_ACTION:
                    this.handleShowAction(state);
                    break;
                case VehicleConfiguratorActions.SHOW_ACTION_V2:
                    this.handleShowV2Action(state, action);
                    break;
                case VehicleConfiguratorActions.SHOW_VEHICLE_NOT_PROVIDED_LAYER:
                    this.handleShowVehicleNotProvidedAction(state);
                    break;
                case VehicleConfiguratorActions.HIDE_VEHICLE_NOT_PROVIDED_LAYER:
                    this.handleHideVehicleNotProvidedAction(state);
                    break;
                case VehicleConfiguratorActions.SET_VEHICLE_NOT_PROVIDED_COMMENT:
                    this.handleSetVehicleNotProvidedCommentAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.HIDE_ACTION:
                    this.handleHideAction(state);
                    break;
                case VehicleConfiguratorActions.SET_MAKE:
                    this.handleSetMakeAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_MODEL:
                    this.handleSetModelAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_YEAR:
                    this.handleSetYearAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_SERIES_CHASSIS:
                    this.handleSetSeriesChassisAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_ENGINE:
                    this.handleSetEngineAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_DETAILS:
                    this.handleSetDetailsAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_TYRES:
                    this.handleSetTyresAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_LOADING_CHECK:
                    this.handleSetLoadingCheckAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_LOADING_CHECK_DONE:
                    this.handleSetLoadingCheckDoneAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_OUT_OF_STOCK:
                    this.handleSetOutOfStockAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_IN_STOCK:
                    this.handleSetInStockAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.SET_VALUES:
                    this.handleSetValuesAction(state, action.payload);
                    break;
                case VehicleConfiguratorActions.RESET_VALUES:
                    state = this.getInitialState();
                    this.__emitChange();
                    break;
                case VehicleConfiguratorActions.SET_POSTCODE:
                    if (state.values[Filters.POSTCODE] !== action.payload) {
                        state.values[Filters.POSTCODE] = action.payload;
                        state.touched = true;
                        this.__emitChange();
                    }

                    break;
                case VehicleConfiguratorActions.SHOW_POSTCODE_INVALID:
                    this.handleShowPostcodeInvalid(state);
                    break;
                case VehicleConfiguratorActions.HIDE_POSTCODE_INVALID:
                    this.handleHidePostcodeInvalid(state);
                    break;
                case VehicleConfiguratorActions.SET_TYRE_OPTIONS:
                    this.handleSetTyreOption(state, action.payload);
                    break;

                case VehicleConfiguratorActions.SET_POSTCODE_SUGGESTION:
                    state.postcodeSuggestion = action.payload;
                    state.postcodeInvalidMessage = false;
                    this.__emitChange();
                    break;
                case VehicleConfiguratorActions.SHOW_INFO_LAYER:
                    state.infoLayerVisible = true;
                    this.__emitChange();
                    break;
                case VehicleConfiguratorActions.HIDE_INFO_LAYER:
                    state.infoLayerVisible = false;
                    this.__emitChange();
                    break;
                default:
                    return false;
            }
        }

        return state;
    }

    handleSetTyreOption(state, tyreOptions) {
        state.tyreOptions = tyreOptions;
        this.__emitChange();
    }

    handleShowPostcodeInvalid(state) {
        if (!state.postcodeInvalidMessage) {
            state.postcodeInvalidMessage = true;
            this.__emitChange();
        }
    }

    handleHidePostcodeInvalid(state) {
        if (state.postcodeInvalidMessage) {
            state.postcodeInvalidMessage = false;
            this.__emitChange();
        }
    }

    handleShowAction(state) {
        if (!state.visible) {
            state.visible = true;
            state.visibleV2 = false;
            state.fromTyreSize = false;
            this.__emitChange();
        }
    }

    handleShowV2Action(state, action) {
        if (!state.visibleV2) {
            state.visible = true;
            state.visibleV2 = true;
            state.fromTyreSize = action.payload;
            this.__emitChange();
        }
    }

    handleShowVehicleNotProvidedAction(state) {
        if (!state.vehicleNotProvidedLayerVisible) {
            state.vehicleNotProvidedLayerVisible = true;
            this.__emitChange();
        }
    }

    handleHideVehicleNotProvidedAction(state) {
        if (state.vehicleNotProvidedLayerVisible) {
            state.vehicleNotProvidedLayerVisible = false;
            this.__emitChange();
        }
    }

    handleSetVehicleNotProvidedCommentAction(state, payload) {
        if (state.values[Filters.VEHICLE_NOT_PROVIDED_COMMENT] !== payload) {
            state.values[Filters.VEHICLE_NOT_PROVIDED_COMMENT] = payload;
            this.__emitChange();
        }
    }

    handleHideAction(state) {
        if (state.visible) {
            state.visible = false;
            state.visibleV2 = false;
            state.fromTyreSize = false;
            this.__emitChange();
        }
    }

    handleSetMakeAction(state, payload) {
        if (state.values[Filters.VEHICLE_MAKE] !== payload) {
            state.values[Filters.VEHICLE_MAKE] = payload;
            this.__emitChange();
        }
    }

    handleSetModelAction(state, payload) {
        if (state.values[Filters.VEHICLE_MODEL] !== payload) {
            state.values[Filters.VEHICLE_MODEL] = payload;
            this.__emitChange();
        }
    }

    handleSetYearAction(state, payload) {
        if (state.values[Filters.VEHICLE_YEAR] !== payload) {
            state.values[Filters.VEHICLE_YEAR] = payload;
            this.__emitChange();
        }
    }

    handleSetSeriesChassisAction(state, payload) {
        if (state.values[Filters.VEHICLE_SERIES_CHASSIS] !== payload) {
            state.values[Filters.VEHICLE_SERIES_CHASSIS] = payload;
            this.__emitChange();
        }
    }

    handleSetEngineAction(state, payload) {
        if (state.values[Filters.VEHICLE_ENGINE] !== payload) {
            state.values[Filters.VEHICLE_ENGINE] = payload;
            this.__emitChange();
        }
    }

    handleSetDetailsAction(state, payload) {
        if (state.values[Filters.VEHICLE_DETAILS] !== payload) {
            state.values[Filters.VEHICLE_DETAILS] = payload.value;
            state.values[Filters.VEHICLE_DETAILS_LABEL] = payload.label;
            this.__emitChange();
        }
    }

    handleSetTyresAction(state, payload) {
        if (state.values[Filters.VEHICLE_TYRES] !== payload) {
            state.values[Filters.VEHICLE_TYRES] = payload;
            this.__emitChange();
        }
    }

    handleSetLoadingCheckAction(state, filterNameToBeChecked) {
        if (state.loadingCheck !== filterNameToBeChecked) {
            state.loadingCheck = filterNameToBeChecked;
            this.__emitChange();
        }
    }

    handleSetLoadingCheckDoneAction(state) {
        if (state.loadingCheck) {
            state.loadingCheck = '';
            this.__emitChange();
        }
    }

    handleSetOutOfStockAction(state, payload) {
        if (state.outOfStock !== payload) {
            state.outOfStock = payload;
            this.__emitChange();
        }
    }

    handleSetInStockAction(state) {
        if (state.outOfStock) {
            state.outOfStock = '';
            this.__emitChange();
        }
    }

    handleSetValuesAction(state, payload) {
        let change = false;

        forOwn(payload, (value, key) => {
            if (typeof state.values[key] !== 'undefined' && payload[key] !== state.values[key]) {
                state.values[key] = payload[key];
                change = true;
            }
        });

        if (change) {
            this.__emitChange();
        }
    }
}

const VehicleFilterStore = new VehicleFilterStoreClass(Dispatcher);
export default VehicleFilterStore;
